const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Pilih paket yang tepat dengan harga sederhana & transparan",
  monthlyUppercase: "BULANAN",
  montly: "Bulanan",
  free: "GRATIS",
  yearlyUppercase: "TAHUNAN",
  yearly: "Tahunan",
  inService: "Dalam pelayanan",
  buyBtn: "Beli sekarang",
  freeTips1: "Mendukung ukuran file maksimum 20MB",
  freeTips2: "6 file per hari",
  freeTips3: "Kecepatan pemrosesan normal",
  freeTips4: "Kecepatan unduh normal",
  freeTips5: "Hapus latar belakang dari 1 foto per hari",
  freeTips6: "Akses ke semua alat gratis",
  vipTips1: "Ukuran file tidak terbatas",
  vipTips2: "File tak terbatas per hari",
  vipTips3: "Kecepatan unduh 10X lebih cepat",
  vipTips4: "Kecepatan pemrosesan 10X lebih cepat",
  vipTips5: "Tak terbatas",
  vipTips6: "Penghapusan latar belakang gambar tanpa batas per hari",
  vipTips7: "Akses ke semua alat & fitur premium",
  vipTips8: "Perbarui secara otomatis dan batalkan kapan saja.",
  vipTips9: "Tidak ada batasan ukuran dan kuantitas video",
  vipTips10: "Hapus latar belakang gambar tanpa batas",
  vipTips11: "Pemrosesan video dan kecepatan unduh 10X lebih cepat",
  vipTips12: "Akses ke semua alat gratis & fitur premium",
  acceptTitle: "Kami Menerima:",
  modalTitle: "Tingkatkan ke Pro untuk mengakses semua fitur premium",
  total: "Total",
  enterCode: "Memasukkan kode",
  SignUpToPurchaseBtn: "Daftar untuk Membeli",
  purchaseBtn: "Pergi ke Pembelian",
  saveTips: "Hemat Hingga {{num}}%",
  discount: "Diskon",
  purchaseTips: "Perbarui secara otomatis dan batalkan kapan saja.",
  tips: "Kiat",
  promoCodeInvalidTips: "Kode promo Anda tidak valid",
};

export default purchase;
